import React, { memo, useState, useMemo } from 'react';
import SVG from 'react-inlinesvg';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AnimateHeight from 'react-animate-height';
import filter from 'lodash/filter';
import map from 'lodash/map';
import classNames from 'classnames/bind';
import styles from './sideBarOption.module.scss';

const conditionalStyles = classNames.bind(styles);

export default memo(withRouter(function SideBarOption(props) {
    const [height, setHeight] = useState(0);
    const [t] = useTranslation('home');

    const result = useMemo(() => {
        if (props.expandable) {
            return filter(props.route.routes, ['list', true]);
        }
    });

    const handleToggle = () => setHeight(height !== 0 ? 0 : 'auto');

    const navigateToSubRoute = path => props.history.push(path);

    const isInSubRoute = () => {
        if (props.expandable) {
            const splittedPathname = props.location.pathname.split('/');
            const splittedPath = props.path.split('/');

            return splittedPathname[1] === splittedPath[1];
        }
    }

    return (
        <div
            className={conditionalStyles({
                container: true,
                fullWidth: props.showTitle
            })}
        >
            <div
                className={conditionalStyles({
                    item: true,
                    open: props.showTitle,
                    active: props.location.pathname === props.path || isInSubRoute()
                })}
                onClick={props.expandable ? handleToggle : props.onClick}
            >
                <SVG cacheGetRequests className={styles.icon} src={props.icon} />
                {props.showTitle && <span className={styles.title}>{t(`home:${props.title}`)}</span>}
                {
                    props.showTitle &&
                    props.expandable &&
                    <SVG
                        cacheGetRequests
                        className={conditionalStyles({
                            collapseIcon: height === 0,
                            collapsedIcon: height !== 0
                        })}
                        src="./icons/collapse.svg"
                    />
                }
            </div>
            {
                props.showTitle &&
                <AnimateHeight animateOpacity duration={500} height={height}>
                    <div className={styles.submenu}>
                        {map(result, (subRoute, index) => (
                            <div className={styles.subRoutes} key={index}>
                                {props.location.pathname === subRoute.path && <div className={styles.dot} />}
                                <div className={styles.item} onClick={navigateToSubRoute.bind(this, subRoute.path)}>
                                    <span>{t(`home:${subRoute.title}`)}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </AnimateHeight>
            }
        </div>
    );
}));
